import React from 'react';
import './Terms.css'

function Terms() {

  return (
    <section className="about">
      <div className="box">
        <h1>
          Terms and Condition<hr />
        </h1>
      </div>

      <div>
<h3> Terms and Conditions - Application "Al-Ajurumiyyah in English"</h3>
<br />
Please read these terms and conditions carefully before using the "Al-Ajurumiyyah in English" application ("Application") available on the Play Store platform. By downloading, accessing, or using this Application, you agree to and are bound by the following terms and conditions: <br /><br /> 

<h4>Usage of the Application</h4>
a. The "Al-Ajurumiyyah in English" application is a mobile application that provides a translation and explanation of ancient arabic book about grammatical rule in arabic language that used till now by modern students or islamic scholar.<br /> 
b. You are allowed to download and use this application on compatible devices, according to the system requirements specified by the Play Store.<br /> 
c. You are solely responsible for the use of this application and agree to comply with all applicable laws. <br /><br />

<h4>Application Content</h4>
a. This application presents list of grammatical rule created by users and/or third parties.<br /> 

b. We reserve the right, without prior notice, to modify, delete, or add any content within this application.<br /><br />

<h4>Intellectual Property Ownership</h4>
a. The "Al-Ajurumiyyah in English" application and all related intellectual property rights remain the property of ours or third parties who have granted us the license.<br /> 
b. You are not granted any rights or licenses to use or exploit the intellectual property rights contained in this application, unless otherwise stated in these terms and conditions..<br /><br />

<h4>User Privacy</h4>
a. We respect user privacy. Information collected or accessed by this application will be handled in accordance with our Privacy Policy.<br /> 
b. We are not responsible for any losses or information leaks caused by factors beyond our control, such as security breaches by third parties or misuse by users.<br /><br />

<h4>Limitation of Liability</h4>
a. We are not responsible for any direct or indirect losses, damages, or claims arising from the use of this application.<br /> 
b. We do not provide any guarantees or warranties regarding the availability, accuracy, reliability, or performance of this application.<br /><br />

<h4>Changes to Terms and Conditions</h4>
a. We reserve the right to modify or update these terms and conditions according to our policies, without prior notice.<br /> 
b. You are obligated to check these terms and conditions periodically. Your use of the application after any changes to the terms and conditions implies that you accept and agree to those changes.<br /><br />

<h4>Termination of Use</h4>
a. We reserve the right to terminate or suspend your use of this application if you violate these terms and conditions.<br /> 
b. We also have the right to terminate or suspend the operation of this application at any time without prior notice.<br /><br />

<h4>Applicable Law</h4>
a. 
These terms and conditions are governed and interpreted in accordance with the laws of our country(Indonesia).<br /> 
b. 
You agree that any dispute arising from or related to the use of this application will be exclusively resolved by the competent courts in our jurisdiction.<br /><br />

By using the "Al-Ajurumiyyah in English" application, you acknowledge and agree that you have read, understood, and consent to be bound by these terms and conditions. If you do not agree with these terms and conditions, please refrain from using this application.<br /><br />

Thank you for using the "Al-Ajurumiyyah in English" application!
      </div>  
    </section>
  );
}

export default Terms;